/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendPaginatedProjectFileListDto } from '../models/backend-paginated-project-file-list-dto';
import { BackendProjectFileDto } from '../models/backend-project-file-dto';
import { projectsFilesDownloadRetrieve } from '../fn/projects-files/projects-files-download-retrieve';
import { ProjectsFilesDownloadRetrieve$Params } from '../fn/projects-files/projects-files-download-retrieve';
import { projectsProjectFilesPartialUpdate } from '../fn/projects-files/projects-project-files-partial-update';
import { projectsProjectFilesPartialUpdate$FormData } from '../fn/projects-files/projects-project-files-partial-update-form-data';
import { ProjectsProjectFilesPartialUpdate$FormData$Params } from '../fn/projects-files/projects-project-files-partial-update-form-data';
import { ProjectsProjectFilesPartialUpdate$Params } from '../fn/projects-files/projects-project-files-partial-update';
import { projectsProjectFilesPartialUpdate$XWwwFormUrlencoded } from '../fn/projects-files/projects-project-files-partial-update-x-www-form-urlencoded';
import { ProjectsProjectFilesPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/projects-files/projects-project-files-partial-update-x-www-form-urlencoded';
import { projectsProjectFilesRetrieve } from '../fn/projects-files/projects-project-files-retrieve';
import { ProjectsProjectFilesRetrieve$Params } from '../fn/projects-files/projects-project-files-retrieve';
import { projectsProjectFilesUpdate } from '../fn/projects-files/projects-project-files-update';
import { projectsProjectFilesUpdate$FormData } from '../fn/projects-files/projects-project-files-update-form-data';
import { ProjectsProjectFilesUpdate$FormData$Params } from '../fn/projects-files/projects-project-files-update-form-data';
import { ProjectsProjectFilesUpdate$Params } from '../fn/projects-files/projects-project-files-update';
import { projectsProjectFilesUpdate$XWwwFormUrlencoded } from '../fn/projects-files/projects-project-files-update-x-www-form-urlencoded';
import { ProjectsProjectFilesUpdate$XWwwFormUrlencoded$Params } from '../fn/projects-files/projects-project-files-update-x-www-form-urlencoded';
import { projectsProjectsFilesCreate } from '../fn/projects-files/projects-projects-files-create';
import { projectsProjectsFilesCreate$FormData } from '../fn/projects-files/projects-projects-files-create-form-data';
import { ProjectsProjectsFilesCreate$FormData$Params } from '../fn/projects-files/projects-projects-files-create-form-data';
import { ProjectsProjectsFilesCreate$Params } from '../fn/projects-files/projects-projects-files-create';
import { projectsProjectsFilesCreate$XWwwFormUrlencoded } from '../fn/projects-files/projects-projects-files-create-x-www-form-urlencoded';
import { ProjectsProjectsFilesCreate$XWwwFormUrlencoded$Params } from '../fn/projects-files/projects-projects-files-create-x-www-form-urlencoded';
import { projectsProjectsFilesList } from '../fn/projects-files/projects-projects-files-list';
import { ProjectsProjectsFilesList$Params } from '../fn/projects-files/projects-projects-files-list';
import { projectsProjectSubscriptionsDelete } from '../fn/projects-files/projects-project-subscriptions-delete';
import { ProjectsProjectSubscriptionsDelete$Params } from '../fn/projects-files/projects-project-subscriptions-delete';

@Injectable({ providedIn: 'root' })
export class BackendApiProjectsFilesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectsFilesDownloadRetrieve()` */
  static readonly ProjectsFilesDownloadRetrievePath = '/api/projects/files/{file_id}/download/';

  /**
   * скачать файл.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsFilesDownloadRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsFilesDownloadRetrieve$Response(
    params: ProjectsFilesDownloadRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectsFilesDownloadRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * скачать файл.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsFilesDownloadRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsFilesDownloadRetrieve(params: ProjectsFilesDownloadRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.projectsFilesDownloadRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectsProjectFilesRetrieve()` */
  static readonly ProjectsProjectFilesRetrievePath = '/api/projects/project/files/{id}/';

  /**
   * Получение информации о файле проекта.
   *
   * Получение информации о файле проекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectFilesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectFilesRetrieve$Response(
    params: ProjectsProjectFilesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectFileDto>> {
    return projectsProjectFilesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Получение информации о файле проекта.
   *
   * Получение информации о файле проекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectFilesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectFilesRetrieve(
    params: ProjectsProjectFilesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendProjectFileDto> {
    return this.projectsProjectFilesRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectFileDto>): BackendProjectFileDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectFilesUpdate()` */
  static readonly ProjectsProjectFilesUpdatePath = '/api/projects/project/files/{id}/';

  /**
   * Обновление информации о файле проекта.
   *
   * Обновление информации о файле проекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectFilesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectFilesUpdate$Response(
    params: ProjectsProjectFilesUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectFileDto>> {
    return projectsProjectFilesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновление информации о файле проекта.
   *
   * Обновление информации о файле проекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectFilesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectFilesUpdate(
    params: ProjectsProjectFilesUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProjectFileDto> {
    return this.projectsProjectFilesUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectFileDto>): BackendProjectFileDto => r.body),
    );
  }

  /**
   * Обновление информации о файле проекта.
   *
   * Обновление информации о файле проекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectFilesUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectFilesUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsProjectFilesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectFileDto>> {
    return projectsProjectFilesUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновление информации о файле проекта.
   *
   * Обновление информации о файле проекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectFilesUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectFilesUpdate$XWwwFormUrlencoded(
    params: ProjectsProjectFilesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProjectFileDto> {
    return this.projectsProjectFilesUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectFileDto>): BackendProjectFileDto => r.body),
    );
  }

  /**
   * Обновление информации о файле проекта.
   *
   * Обновление информации о файле проекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectFilesUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectFilesUpdate$FormData$Response(
    params: ProjectsProjectFilesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectFileDto>> {
    return projectsProjectFilesUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновление информации о файле проекта.
   *
   * Обновление информации о файле проекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectFilesUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectFilesUpdate$FormData(
    params: ProjectsProjectFilesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProjectFileDto> {
    return this.projectsProjectFilesUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectFileDto>): BackendProjectFileDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectSubscriptionsDelete()` */
  static readonly ProjectsProjectSubscriptionsDeletePath = '/api/projects/project/files/{id}/';

  /**
   * Удаление файла проекта.
   *
   * Удаление файла проекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectSubscriptionsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectSubscriptionsDelete$Response(
    params: ProjectsProjectSubscriptionsDelete$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectsProjectSubscriptionsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Удаление файла проекта.
   *
   * Удаление файла проекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectSubscriptionsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectSubscriptionsDelete(
    params: ProjectsProjectSubscriptionsDelete$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectsProjectSubscriptionsDelete$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectsProjectFilesPartialUpdate()` */
  static readonly ProjectsProjectFilesPartialUpdatePath = '/api/projects/project/files/{id}/';

  /**
   * Получение, обновление и удаление файла проекта.
   *
   * Этот эндпоинт предоставляет возможность получения, обновления и удаления информации о конкретном файле проекта.
   *
   * Параметры запроса:
   * - `pk` (int): Идентификатор файла проекта.
   *
   * HTTP-методы:
   * - GET: Получение информации о файле проекта.
   * - PUT: Обновление информации о файле проекта.
   * - DELETE: Удаление файла проекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectFilesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectFilesPartialUpdate$Response(
    params: ProjectsProjectFilesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectFileDto>> {
    return projectsProjectFilesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Получение, обновление и удаление файла проекта.
   *
   * Этот эндпоинт предоставляет возможность получения, обновления и удаления информации о конкретном файле проекта.
   *
   * Параметры запроса:
   * - `pk` (int): Идентификатор файла проекта.
   *
   * HTTP-методы:
   * - GET: Получение информации о файле проекта.
   * - PUT: Обновление информации о файле проекта.
   * - DELETE: Удаление файла проекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectFilesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectFilesPartialUpdate(
    params: ProjectsProjectFilesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProjectFileDto> {
    return this.projectsProjectFilesPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectFileDto>): BackendProjectFileDto => r.body),
    );
  }

  /**
   * Получение, обновление и удаление файла проекта.
   *
   * Этот эндпоинт предоставляет возможность получения, обновления и удаления информации о конкретном файле проекта.
   *
   * Параметры запроса:
   * - `pk` (int): Идентификатор файла проекта.
   *
   * HTTP-методы:
   * - GET: Получение информации о файле проекта.
   * - PUT: Обновление информации о файле проекта.
   * - DELETE: Удаление файла проекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectFilesPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectFilesPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsProjectFilesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectFileDto>> {
    return projectsProjectFilesPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Получение, обновление и удаление файла проекта.
   *
   * Этот эндпоинт предоставляет возможность получения, обновления и удаления информации о конкретном файле проекта.
   *
   * Параметры запроса:
   * - `pk` (int): Идентификатор файла проекта.
   *
   * HTTP-методы:
   * - GET: Получение информации о файле проекта.
   * - PUT: Обновление информации о файле проекта.
   * - DELETE: Удаление файла проекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectFilesPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectFilesPartialUpdate$XWwwFormUrlencoded(
    params: ProjectsProjectFilesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProjectFileDto> {
    return this.projectsProjectFilesPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectFileDto>): BackendProjectFileDto => r.body),
    );
  }

  /**
   * Получение, обновление и удаление файла проекта.
   *
   * Этот эндпоинт предоставляет возможность получения, обновления и удаления информации о конкретном файле проекта.
   *
   * Параметры запроса:
   * - `pk` (int): Идентификатор файла проекта.
   *
   * HTTP-методы:
   * - GET: Получение информации о файле проекта.
   * - PUT: Обновление информации о файле проекта.
   * - DELETE: Удаление файла проекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectFilesPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectFilesPartialUpdate$FormData$Response(
    params: ProjectsProjectFilesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectFileDto>> {
    return projectsProjectFilesPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Получение, обновление и удаление файла проекта.
   *
   * Этот эндпоинт предоставляет возможность получения, обновления и удаления информации о конкретном файле проекта.
   *
   * Параметры запроса:
   * - `pk` (int): Идентификатор файла проекта.
   *
   * HTTP-методы:
   * - GET: Получение информации о файле проекта.
   * - PUT: Обновление информации о файле проекта.
   * - DELETE: Удаление файла проекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectFilesPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectFilesPartialUpdate$FormData(
    params: ProjectsProjectFilesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProjectFileDto> {
    return this.projectsProjectFilesPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectFileDto>): BackendProjectFileDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectsFilesList()` */
  static readonly ProjectsProjectsFilesListPath = '/api/projects/projects/files/';

  /**
   * Получение списка файлов проекта.
   *
   * Список файлов проекта
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsFilesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsFilesList$Response(
    params?: ProjectsProjectsFilesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedProjectFileListDto>> {
    return projectsProjectsFilesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Получение списка файлов проекта.
   *
   * Список файлов проекта
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsFilesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsFilesList(
    params?: ProjectsProjectsFilesList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedProjectFileListDto> {
    return this.projectsProjectsFilesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendPaginatedProjectFileListDto>): BackendPaginatedProjectFileListDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectsFilesCreate()` */
  static readonly ProjectsProjectsFilesCreatePath = '/api/projects/projects/files/';

  /**
   * Добавление нового файла проекта.
   *
   * Добавление нового файла проекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsFilesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectsFilesCreate$Response(
    params: ProjectsProjectsFilesCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectFileDto>> {
    return projectsProjectsFilesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Добавление нового файла проекта.
   *
   * Добавление нового файла проекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsFilesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectsFilesCreate(
    params: ProjectsProjectsFilesCreate$Params,
    context?: HttpContext,
  ): Observable<BackendProjectFileDto> {
    return this.projectsProjectsFilesCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectFileDto>): BackendProjectFileDto => r.body),
    );
  }

  /**
   * Добавление нового файла проекта.
   *
   * Добавление нового файла проекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsFilesCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectsFilesCreate$XWwwFormUrlencoded$Response(
    params: ProjectsProjectsFilesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectFileDto>> {
    return projectsProjectsFilesCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Добавление нового файла проекта.
   *
   * Добавление нового файла проекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsFilesCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectsFilesCreate$XWwwFormUrlencoded(
    params: ProjectsProjectsFilesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProjectFileDto> {
    return this.projectsProjectsFilesCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectFileDto>): BackendProjectFileDto => r.body),
    );
  }

  /**
   * Добавление нового файла проекта.
   *
   * Добавление нового файла проекта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsFilesCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectsFilesCreate$FormData$Response(
    params: ProjectsProjectsFilesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectFileDto>> {
    return projectsProjectsFilesCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Добавление нового файла проекта.
   *
   * Добавление нового файла проекта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsFilesCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectsFilesCreate$FormData(
    params: ProjectsProjectsFilesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProjectFileDto> {
    return this.projectsProjectsFilesCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectFileDto>): BackendProjectFileDto => r.body),
    );
  }
}
